(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-reviews-accordion"] && !Shopify.designMode) return;
  try {
    function syncProductReviewSummary() {
    const source = document.querySelector('.product__info-container .skeepers_product__stars');
    const scoreText = source?.querySelector('.rate-aggregate')?.textContent.trim();
    const count = source?.querySelector('.rate-total')?.textContent.match(/\d+/)?.[0];
    const score = Number(scoreText?.replace(',', '.'));
    document.querySelectorAll('.product-reviews-accordion__rating').forEach((rating) => {
      const ready = Boolean(count) && Number.isFinite(score) && score >= 0 && score <= 5;
      rating.hidden = !ready;
      if (!ready) return;
      const label = rating.dataset.countLabel.replace('__count__', count);
      rating.setAttribute('aria-label', `${scoreText}/5, ${label}`);
      rating.querySelector('[data-review-count]').textContent = label;
      rating.style.setProperty('--rating-fill', `${score * 20}%`);
    });
  }
  const productReviewSource = document.querySelector('.product__title-rating');
  if (productReviewSource) new MutationObserver(syncProductReviewSummary).observe(productReviewSource, { childList: true, subtree: true, characterData: true });
  syncProductReviewSummary();
  function setProductReviewsExpanded(reviews, expanded) {
    reviews.classList.toggle('is-expanded', expanded);
    const button = reviews.querySelector('.product-reviews-accordion__expand');
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
  }
  document.querySelectorAll('.product-reviews-accordion__expand').forEach((button) => {
    button.addEventListener('click', () => {
      const reviews = button.closest('.product-reviews-accordion');
      const expanded = !reviews.classList.contains('is-expanded');
      setProductReviewsExpanded(reviews, expanded);
      if (!expanded) reviews.scrollIntoView({ block: 'start' });
    });
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.product__info-container .skeepers_product__stars, a[href="#skeepers_product_widget"]')) return;
    const reviews = document.querySelector('.product-reviews-accordion');
    if (reviews) setProductReviewsExpanded(reviews, true);
  }, true);
  function revealLinkedProductReviews() {
    if (window.location.hash !== '#skeepers_product_widget') return;
    const reviews = document.querySelector('.product-reviews-accordion');
    if (reviews) setProductReviewsExpanded(reviews, true);
  }
  window.addEventListener('hashchange', revealLinkedProductReviews);
  revealLinkedProductReviews();
  } catch(e) { console.error(e); }
})();

})();
